<template>
  <div class="container white">
    <div class="row">
      <div class="col-12">
        <FiltrosNotasPendentes @filtroMostrarTipo="handleFiltroMostrarTipo" @filters-applied="handleFilters" @filter-mode-changed="handleFilterModeChanged" />
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="mb-0 text-uppercase">Lista de professores e disciplinas com notas não publicadas no sistema
            </h4>
          </div>
          <div class="card-body">

            <div v-if="isLoading" class="text-center my-3">
              <span class="spinner-border text-primary" role="status" aria-hidden="true"></span>
              <span class="ml-2">Carregando...</span>
            </div>

            <TabelaResultados key="resultados" v-if="!isLoading" :dados="resultados" :tipo-resultado="tipoResultado" @refresh-results="refreshData" />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/plugins/axios.js';
import FiltrosNotasPendentes from './pauta/pauta-nao-lancadas/FiltrosNotasPendentes.vue';
import TabelaResultados from './pauta/TabelaResultados.vue';
const ls = require("local-storage")

export default {
  components: {
    FiltrosNotasPendentes,
    TabelaResultados
  },
  data() {
    return {
      isLoading: false,
      resultados: [],
      tipoResultado: 'porAno',
      filters: {
        anoLectivo: '',
        curso: '',
        idTipoNota: '',
        isNotaLancada: '',
        tipoNota: '',
        classe: '',
        turma: ''
      }
    };
  },
  watch: {
    tipoResultado(newValue, oldValue) {
      this.resultados = [];
    },

  },
  methods: {
    async refreshData() {
      try {
        this.isLoading = true;
        await this.handleFilters(this.filters);
      } catch (error) {
        console.error('Error refreshing data:', error);
        this.showMessageSnackbar('Erro ao atualizar os dados', 'error');
      } finally {
        this.isLoading = false;
      }
    },
    
    handleFiltroMostrarTipo(filtro) {
      console.log(filtro);
    },

    async handleFilters(recebidos) {
      this.resultados = [];
      this.filters = { ...recebidos };
      this.isLoading = true;
      this.tipoResultado = 'porAno';

      const { anoLectivo, idTipoNota, isNotaLancada } = recebidos;
      const idInstituicao = ls.get("i_id");

      try {
      if (isNotaLancada == 1) {
        this.tipoResultado = 'porAno';
        const { data } = await axios.get(`/buscarDisciplinasComNotasLancadasPorAnoTipo/${anoLectivo}/${idInstituicao}/${idTipoNota}`);
        this.resultados = data;
        this.isLoading = false;
      }
      else if (isNotaLancada == 2) {
        this.tipoResultado = 'porAno';
        const { data } = await axios.get(`/buscarTodasDisciplinasComSemNotasLancadasPorAnoTipo/${anoLectivo}/${idInstituicao}/${idTipoNota}`);
        this.resultados = data;
        this.isLoading = false;
      }
      else {
        this.tipoResultado = 'porAno';
        const { data } = await axios.get(`/buscarDisciplinasSemNotaLancada/${anoLectivo}/${idInstituicao}/${idTipoNota}`);
        this.resultados = data;
        this.isLoading = false;
      }
    }

      catch (error) {
        this.showMessageSnackbar(`Erro ao carregar dados: ${error.message}`, "error");
      } finally {
        this.isLoading = false;
      }

   
    },

    handleFilterModeChanged(novoModoTurma) {
      this.tipoResultado = 'porAno';
      this.resultados = [];
      this.filters = {
        anoLectivo: '',
        curso: '',
        idTipoNota: '',
        isNotaLancada: '',
        tipoNota: '',
        classe: '',
        turma: ''
      };
    },

    showMessageSnackbar(mensagem, tipo = 'info') {
      alert(`[${tipo.toUpperCase()}] ${mensagem}`);
    }
  }
};
</script>

<style scoped>
.card {
  border: 1px solid #e3e6f0;
  border-radius: 0.35rem;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}

.card-header {
  background-color: #f8f9fc;
  border-bottom: 1px solid #e3e6f0;
  padding: 1rem;
}

.card-header h4 {
  color: #3d3d3d;
  font-weight: 600;
}

.card-body {
  padding: 1.75rem;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}
</style>